import { render, staticRenderFns } from "./IFacesChart.vue?vue&type=template&id=0bb91ed4&scoped=true"
import script from "./IFacesChart.vue?vue&type=script&lang=js"
export * from "./IFacesChart.vue?vue&type=script&lang=js"
import style0 from "./IFacesChart.vue?vue&type=style&index=0&id=0bb91ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb91ed4",
  null
  
)

export default component.exports